<p class="text-label mb-1" *ngIf="showRecommendationMessage">
    {{ 'app.file_upload.el_archivo_debe_pesar' | translate }}
</p>
<p class="text-label mb-2" *ngIf="isFavicon">Es el icono que identifica a tu sitio en la pestaña del navegador.</p>

<div class="image-container d-flex justify-content-center align-items-center w-100" (click)="openImageManager()">
    <div class="d-flex justify-content-center align-items-center w-100 h-100">
        <div
            *ngIf="!urlLogo && !logoLoaded; else elseBlock"
            id="upload-icon"
            class="d-flex flex-column justify-content-center align-items-center"
        >
            <i class="fal fa-upload mb-1 color-texto"></i>
            <p class="m-0 mt-1 color-texto text-center">{{ 'app.file_upload.selecciona' | translate }}</p>
        </div>
        <ng-template #elseBlock>
            <img
                [src]="urlLogo ? urlLogo : logoLoaded"
                id="without-logo"
                [className]="applyFaviconClass ? 'favico' : ''"
            />
        </ng-template>
    </div>
    <div [ngClass]="!urlLogo && !logoLoaded ? 'd-none' : ''" class="flex-row image-options rounded">
        <i
            *ngIf="showReplaceBtn"
            class="fal fa-arrows-repeat mr-2"
            (click)="openImageManager(); $event.stopPropagation()"
        ></i>
        <i *ngIf="showDeleteBtn" class="fal fa-trash" (click)="deleteLogo(); $event.stopPropagation()"></i>
    </div>
</div>
